import { CodedProperty, NamedProperty } from "sprint-common-web";

import { AncillaryContentSubtype } from "../../common/types/AncillaryContentType";
import { ContentSubtype } from "../../common/types/ContentSubtype";
import { MovieContentSubtype } from "../../common/types/MovieContentSubtype";
import { TvSeriesContentSubtype } from "../../common/types/TvSeriesContentSubtype";
import { renderBrandedContentVersionText } from "../../common/utils/renderContentVersionText";

export const useAssociateHistory = () => {
    const localStorageKeys = {
        SUBMISSIONS_HISTORY: "submissionsHistory"
    };

    const save = (content: SubmissionsHistoryContent) => {
        const previousSubmissions = read();

        const uniquePreviousSubmissions = previousSubmissions.filter(
            (item) => JSON.stringify(item) !== JSON.stringify(content)
        );

        const newSubmissions = [content, ...uniquePreviousSubmissions].slice(0, 10);

        localStorage.setItem(localStorageKeys.SUBMISSIONS_HISTORY, JSON.stringify(newSubmissions));
    };

    const read = (): SubmissionsHistoryContent[] => {
        const submissionsHistory = localStorage.getItem(localStorageKeys.SUBMISSIONS_HISTORY);
        return submissionsHistory ? (JSON.parse(submissionsHistory) as SubmissionsHistoryContent[]) : [];
    };

    const isHistoryEmpty = !read().length;

    return {
        save,
        read,
        isHistoryEmpty
    };
};

export type SubmissionsHistoryContent = MovieHistoryContent | AncillaryHistoryContent | TvSeriesHistoryContent;

interface HistoryContentBase {
    id: string;
    type: ContentSubtype;
    title: string;
    versions: { id: string; name: string }[];
}

export interface MovieHistoryContent extends HistoryContentBase {
    versions: { id: string; name: string }[];
    type: MovieContentSubtype;
}

export interface AncillaryHistoryContent extends HistoryContentBase {
    airline: CodedProperty;
    type: AncillaryContentSubtype;
}

export interface TvSeriesHistoryContent extends HistoryContentBase {
    seasonId: string;
    episodeId: string;
    type: TvSeriesContentSubtype;
}

export const mapToVersionText = (
    distributor: NamedProperty,
    type: NamedProperty,
    brandings?: CodedProperty[]
): string =>
    renderBrandedContentVersionText({
        distributor,
        type,
        brandings
    });
